module.exports = __webpack_public_path__ + "static/media/pb-qr.c9da30c8.png";